import React from "react";

const steps = [
  {
    icon: "🧩",
    title: "Plug In",
    body: "Connect your phone, website chat, or inbox. Add FAQs & availability.",
    outcome: "Up and running in minutes.",
  },
  {
    icon: "🤖",
    title: "We Answer",
    body:
      "AI receptionist responds 24/7, qualifies leads, and books appointments.",
    outcome: "No more missed calls—or missed sales.",
  },
  {
    icon: "📈",
    title: "You Grow",
    body:
      "Leads flow to your CRM. See dashboards, transcripts, and outcomes.",
    outcome: "More bookings. Lower costs. Less stress.",
  },
];

export default function HowItWorks() {
  return (
    <section className="lk-section lk-how">
      <div className="lk-container">
        <h2>How It Works</h2>
        <div className="lk-steps">
          {steps.map((s) => (
            <div className="lk-step" key={s.title}>
              <div className="lk-step-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
              <div className="lk-step-outcome">{s.outcome}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
